import React, { useState } from 'react'

export const TutorialContext = React.createContext()

export const TutorialProvider = (props) => {
  const [showTutorial, setShowTutorial] = useState()
  return (
    <TutorialContext.Provider value={{ showTutorial, setShowTutorial }}>
      {props.children}
    </TutorialContext.Provider>
  )
}
